var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","margin":"20px"}},[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick}},[_c('el-tab-pane',{attrs:{"label":"平台企业"}},[_c('plateformCompanyList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }